import { ErrorMessage, Field, FieldArray, Formik, FormikProvider, useFormik } from "formik";
import { debounce, initial, set } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormFeedback, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Pagination, PaginationItem, PaginationLink, Row, Spinner, Table, Toast, ToastBody, ToastHeader } from "reactstrap";
import './CommandeLine.css';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaBox, FaBoxes, FaCog, FaEdit, FaImage, FaList, FaMoneyBillWave, FaPlus, FaSave, FaSearch, FaTag, FaTh, FaTimes, FaTrash, FaWarehouse } from "react-icons/fa";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { supplierActions } from "../../sagas/supplierSlice";
import Swal from "sweetalert2";
import { productActions } from "../../sagas/productSlice";
import config from "../../helpers/config";
import { formatPrice, getPrixAchat, roundToNearestInteger } from "../../helpers/utility";
import Select from 'react-select';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import { categoryActions } from "../../sagas/categorySlice";


const CommandeLine = ({ formik, disabled }) => {
    const { values, setFieldValue } = formik;
    const [items, setItems] = useState([]);
    const [productModal, setProductModal] = useState(false);
    const toggleProductModal = () => setProductModal(!productModal);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [chooseProductModal, setChooseProductModal] = useState(false);
    const toggleChooseProductModal = () => setChooseProductModal(!chooseProductModal);
    const [modalSearchTerm, setModalSearchTerm] = useState('');
    const [displayMode, setDisplayMode] = useState('table');
    const { list } = useSelector(state => state.categories); // Assuming you have a Redux store with categories

    const TVA_OPTIONS = [
        { code: 0.2, libelle: '20%' },
        { code: 0.1, libelle: '10%' },
        { code: 0.01, libelle: '7%' },
        { code: 0.14, libelle: '14%' }
    ];

    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unite

    const {
        products,
        loading,
        totalPages,
        totalElements,
        pageNumber,
        pageSize,
        error,
    } = useSelector((status) => status.products);


    const dispatch = useDispatch();
    const [isSearching, setIsSearching] = useState(false);


    useEffect(() => {
        console.log(values)
        dispatch(productActions.findAllUnites());
        setItems(values.lignes.map(l => {
            // Find product by articleId
            const product = products?.find(p => p.id === l.articleId);
            let prices = l.prices;
            if (!prices && product) {
                prices = [product.prixVenteTTC1, product.prixVenteTTC2, product.prixVenteTTC3].filter(Boolean);
            } else if (!prices) {
                prices = [l.prixUnitaireTTC].filter(Boolean);
            }
            return {
                ...l,
                unite: unites.find(u => u.code === l.unite)?.libelle,
                prices,
            };
        }));
        dispatch(categoryActions.list({query:''})); // Fetch categories if needed

    }, [values.lignes]);

    useEffect(() => {
        dispatch(productActions.findAll({
            search: searchTerm,
            page: currentPage - 1,
            size: 10,
        }));

    }, [currentPage, chooseProductModal]);


    const handleInputChange = (index, event) => {
        const newItems = [...items];
        const updatedItem = { ...newItems[index], [event.target.name]: event.target.value };
        newItems[index] = updatedItem;


        // Calculate montantHT and montantTTC for the current item
        const quantity = parseFloat(newItems[index].quantite) || 0;
        const unitPriceTTC = parseFloat(newItems[index].prixUnitaireTTC) || 0;
        const tauxTVA = parseFloat(newItems[index].tauxTVA) || 0;
        const unitPriceHT = (unitPriceTTC / (1 + tauxTVA)).toFixed(2);
        const montantHT = (quantity * unitPriceHT).toFixed(2);
        const montantTTC = unitPriceTTC * quantity;

        // Update the montantHT and montantTTC in the newItems array
        newItems[index].montantHT = montantHT;
        newItems[index].montantTTC = montantTTC;
        newItems[index].prixUnitaireHT = unitPriceHT;

        // Recalculate htCumul and ttcCumul
        let newHtCumul = 0;
        let newTtcCumul = 0;
        newItems.forEach(item => {
            newHtCumul += (parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0);
            newTtcCumul += ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * (1 + (parseFloat(item.tauxTVA) || 0));
        });

        // Calculate montantTotalTaxe
        let montantTotalTaxe = 0;
        newItems.forEach(item => {
            const itemTva = ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * ((parseFloat(item.tauxTVA) || 0));
            montantTotalTaxe += itemTva;
        });

        setItems(newItems);
        setFieldValue('lignes', newItems);
        setFieldValue('montantTotalTaxe', roundToNearestInteger(montantTotalTaxe));
        setFieldValue('montantTotalHT', roundToNearestInteger(newHtCumul));
        setFieldValue('montantTotalTTC', roundToNearestInteger(newTtcCumul));
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };


    const DisplayToggle = () => (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="btn-group">
                <Button
                    color={displayMode === 'table' ? 'primary' : 'light'}
                    onClick={() => setDisplayMode('table')}
                    size="sm"
                >
                    <FaList className="me-1" /> {t('common.table')}
                </Button>
                <Button
                    color={displayMode === 'card' ? 'primary' : 'light'}
                    onClick={() => setDisplayMode('card')}
                    size="sm"
                >
                    <FaTh className="me-1" /> {t('common.cards')}
                </Button>
            </div>

            <div className="d-flex align-items-center gap-3">
                <small className="text-muted">
                    {t('product.showing', {
                        start: (currentPage - 1) * pageSize + 1,
                        end: Math.min(currentPage * pageSize, totalElements),
                        total: totalElements,
                        currentPage: currentPage,
                        totalPages: totalPages
                    })}
                </small>

                <div className="d-flex align-items-center gap-2">
                    <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
                        <FaAngleDoubleLeft />
                    </Button>
                    <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        <FaAngleLeft />
                    </Button>

                    <span className="mx-2">
                        {currentPage} / {totalPages}
                    </span>

                    <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        <FaAngleRight />
                    </Button>
                    <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                        <FaAngleDoubleRight />
                    </Button>
                </div>
            </div>
        </div>
    );


    const handleDeleteItem = (index) => {
        const newItems = [...items];
        newItems.splice(index, 1);
        setItems(newItems);
        setFieldValue('lignes', newItems);
        // Recalculate htCumul and ttcCumul after deleting an item
        let newHtCumul = 0;
        let newTtcCumul = 0;
        let montantTotalTaxe = 0;

        newItems.forEach(item => {
            newHtCumul += (parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0);
            newTtcCumul += ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * (1 + (parseFloat(item.tauxTVA) || 0));
            montantTotalTaxe += ((parseFloat(item.quantite) || 0) * (parseFloat(item.prixUnitaireHT) || 0)) * ((parseFloat(item.tauxTVA) || 0));
        });

        setFieldValue('montantTotalTaxe', roundToNearestInteger(montantTotalTaxe));
        setFieldValue('montantTotalHT', roundToNearestInteger(newHtCumul));
        setFieldValue('montantTotalTTC', roundToNearestInteger(newTtcCumul));

    };

    const debouncedModalSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(productActions.findAll({
                search: query,
                page: 0,
                size: pageSize,
                onSuccess: () => setIsSearching(false),
                onError: () => setIsSearching(false)
            }));
        }, 1000), // Wait 1 second after user stops typing
        [modalSearchTerm]
    );


    // Handle modal search input change
    const handleModalSearchChange = (e) => {
        const value = e.target.value;
        setModalSearchTerm(value);
        debouncedModalSearch(value);
    };

    const handleProductSelect = async (product) => {
        if (!values.clientId) {
            Swal.fire({
                icon: 'warning',
                title: t('devis.noClientTitle'),
                text: t('devis.noClientMessage'),
                confirmButtonText: t('common.ok', 'OK')
            });
            setModalSearchTerm(''); // Clear the search term
            toggleChooseProductModal(); // Close the product modal

            return;
        }


        // Check if product already exists in items array
        const productExists = items.some(item => item.articleId === product.id);

        if (productExists) {
            // Show warning message using Swal
            Swal.fire({
                icon: 'warning',
                title: t('purchase.productExistsTitle'),
                text: t('purchase.productExistsMessage'),
                confirmButtonText: t('common.ok')
            });
            return;
        }
        const prices = [product.prixVenteTTC1, product.prixVenteTTC2, product.prixVenteTTC3];

        const newItem = {
            articleId: product.id,
            articleNom: product.libelle,
            prices: prices,
            quantite: 1,
            prixUnitaireTTC: roundToNearestInteger(product.prixVenteTTC1),
            prixUnitaireHT: roundToNearestInteger(product.prixVenteTTC1 / (1 + (product.tauxTVAVente || 0.2))),
            unite: unites.find(u => u.code === product.unite).libelle,
            tauxTVA: product.tauxTVAVente || 0.2,
            montantHT: roundToNearestInteger(product.prixVenteTTC1 / (1 + (product.tauxTVAVente || 0.2))),
            montantTTC: roundToNearestInteger(product.prixVenteTTC1),
        };

        const newItems = [...items, newItem];
        setItems(newItems);
        setFieldValue('lignes', newItems);

        // Recalculate total amounts after adding a new item
        let newHtCumul = 0;
        let newTtcCumul = 0;
        let montantTotalTaxe = 0;

        newItems.forEach(item => {
            const quantity = parseFloat(item.quantite) || 0;
            const unitPrice = parseFloat(item.prixUnitaireHT) || 0;
            const tauxTVA = parseFloat(item.tauxTVA) || 0;

            newHtCumul += quantity * unitPrice;
            newTtcCumul += (quantity * unitPrice) * (1 + tauxTVA);
            montantTotalTaxe += (quantity * unitPrice) * tauxTVA;
        });

        setFieldValue('montantTotalTaxe', roundToNearestInteger(montantTotalTaxe));
        setFieldValue('montantTotalHT', roundToNearestInteger(newHtCumul));
        setFieldValue('montantTotalTTC', roundToNearestInteger(newTtcCumul));

        setModalSearchTerm('');
        toggleChooseProductModal();
    };





    const TableView = () => (
        <>
            <div className="cart-container" style={{
                height: '300px',
                overflowY: 'auto'
            }}>

                <Table hover bordered className="align-middle mb-0">
                    <thead className="bg-light">
                        <tr>
                            <th className="align-middle">
                                <FaBarcode className="me-2 text-primary" size={12} />
                                {t('product.code')}
                            </th>
                            <th className="align-middle">
                                <FaBox className="me-2 text-primary" size={12} />
                                {t('product.description')}
                            </th>
                            <th className="align-middle text-end">
                                <FaTag className="me-2 text-primary" size={12} />
                                {t('product.salePrice')}
                            </th>
                            {/* <th className="align-middle text-end">
                                <FaTag className="me-2 text-primary" size={12} />
                                {t('product.buyingPrice')}
                            </th> */}
                            <th className="align-middle text-center">
                                <FaBoxes className="me-2 text-primary" size={12} />
                                {t('product.stockPhysique')}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {!products || products.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center py-4">
                                    <div className="text-muted">
                                        {t('product.noProducts')}
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            products.map((product) => (
                                <tr key={product.id} onClick={() => handleProductSelect(product)}>
                                    <td className="align-middle">{product.code}</td>
                                    <td className="align-middle">
                                        {product.libelle.length > 30 ? product.libelle.substring(0, 30) + '...' : product.libelle}
                                    </td>
                                    <td className="align-middle text-end">
                                        {formatPrice(product.prixVenteTTC1)}
                                    </td>
                                    {/* <td className="align-middle text-end">{formatPrice(product.prixAchatTTC)}</td> */}
                                    <td className="align-middle text-center">{product.stockPhysique}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <small className="text-muted">
                    {t('product.showing', {
                        start: (currentPage - 1) * pageSize + 1,
                        end: Math.min(currentPage * pageSize, totalElements),
                        total: totalElements,
                        currentPage: currentPage,
                        totalPages: totalPages
                    })}
                </small>
            </div>
        </>
    );

    const CardView = () => (
        <div className="card-container" style={{ height: '400px', overflowY: 'auto' }}>
            <Row xs={2} md={3} lg={3} className="g-3">
                {(!products || products.length === 0) && (
                    <Col xs={12} className="text-center py-4 ">
                        {t('product.noProducts')}
                    </Col>
                )}
                {products.map(product => (
                    <Col key={product.id}>
                        <Card className="product-card rounded border shadow-sm" onClick={() => handleProductSelect(product)}>
                            <div className="card-image-container">
                                {product.photo ? (
                                    <img
                                        src={`${config.baseURL}${product.photo}`}
                                        alt={product.libelle}
                                        className="card-img-top rounded-top"
                                    />
                                ) : (
                                    <div className="bg-placeholder rounded-top d-flex align-items-center justify-content-center">
                                        <FaImage size={32} className="text-muted" />
                                    </div>
                                )}
                            </div>
                            <CardBody className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-start">
                                    <h6 className="product-title mb-2">
                                        {product.libelle.length > 30 ? product.libelle.substring(0, 30) + '...' : product.libelle}
                                    </h6>
                                </div>
                                {product.unite ? `${formatPrice(product.prixVenteTTC1)} / ${product.unite}` : 'N/A'}
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );

    return (
        <Container fluid>
            <Table bordered>
                <thead>
                    <tr>
                        <th style={{ width: "250px" }}>{t('devis.article')}</th>
                        <th>{t('devis.quantite')}</th>
                        <th>{t('devis.unite')}</th>
                        <th style={{ width: "200px" }}>{t('devis.prixUnitaireTTC')}</th>
                        <th>{t('devis.prixUnitaireHT')}</th>
                        <th>{t('devis.montantHT')}</th>
                        <th>{t('devis.tauxTVA')}</th>
                        <th>{t('devis.montantTTC')}</th>
                        <th>{t('common.actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length === 0 ? (
                        <tr>
                            <td colSpan="9" className="text-center py-4">
                                <div className="text-muted">
                                    {t('purchase.noItems')}

                                </div>
                            </td>
                        </tr>
                    ) : (
                        items.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <Input
                                        type="text"
                                        name="articleNom"
                                        value={item.articleNom}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="quantite"
                                        value={item.quantite}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled={disabled}

                                    />
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name="unite"
                                        value={item.unite}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled
                                    />
                                </td>
                                <td style={{ width: '100px' }}>
                                    <Input
                                        type="select"
                                        name="prixUnitaireTTC"
                                        value={item.prixUnitaireTTC}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled={disabled}
                                    >
                                        {item.prices && item.prices.map((price, priceIndex) => (
                                            <option key={priceIndex} value={price}>
                                                {formatPrice(price, false)}
                                            </option>
                                        ))}
                                    </Input>
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="prixUnitaireHT"
                                        value={item.prixUnitaireHT}
                                        onChange={(event) => handleInputChange(index, event)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        onFocus={(e) => e.target.select()} // Select the field content on focus
                                        name="montantHT"
                                        value={item.montantHT}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="select"
                                        name="tauxTVA"
                                        onChange={(event) => handleInputChange(index, event)}
                                        value={item.tauxTVA}
                                        disabled={disabled}
                                    >
                                        {TVA_OPTIONS.map(option => (
                                            <option key={option.code} value={option.code}>
                                                {option.libelle}
                                            </option>
                                        ))}
                                    </Input>
                                </td>
                                <td>
                                    <Input
                                        type="text"
                                        name="montantTTC"
                                        value={formatPrice(item.montantTTC, false)}
                                        disabled
                                    />
                                </td>
                                <td>
                                    <Button color="danger" onClick={() => handleDeleteItem(index)} 
                                        size="sm" disabled={disabled} 
                                    >
                                        <FaTrash />
                                    </Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
            <Button color="primary" onClick={toggleChooseProductModal}
                disabled={disabled} className="mb-3"
            >
                <FaPlus /> {t('facture.addLine')}
            </Button>
            <Modal isOpen={chooseProductModal} toggle={toggleChooseProductModal} size="xl">
                <ModalHeader toggle={toggleChooseProductModal}>
                    {t('product.chooseProduct')}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <Input
                                type="text"
                                placeholder={t('product.searchPlaceholder')}
                                value={modalSearchTerm}
                                onChange={handleModalSearchChange}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }
                                }}
                                className="me-2" // Added margin to the right
                            />
                        </Col>

                    </Row>
                    <DisplayToggle />
                    {displayMode === 'table' ? <TableView /> : <CardView />}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => {
                        setModalSearchTerm('');
                        setCurrentPage(1);
                        toggleChooseProductModal()
                    }}>
                        {t('common.cancel')}
                    </Button>
                </ModalFooter>
            </Modal>


        </Container>
    );
};
export default CommandeLine;
